import { createAction, props } from '@ngrx/store';

const GET_APP_NAVIGATION = '[Screens] Get App Navigation';
const SET_APP_NAVIGATION = '[Screens] Set App Navigation';
const GET_SCREENS = '[Screens] Get Screens';
const GET_ID_MAPPING = '[Screens] Get Id Mapping';
const SET_ID_MAPPING = '[Screens] Set Id Mapping';
const SAVE_SCREENS = '[Screens] Save Screens';
const UPDATE_SCREENS = '[Screens] Update Screens';
const UPDATE_SCREEN = '[Screens] Update Screen';
const SET_SELECTED_SCREENS = '[Screens] Set Selected Screens';
const DELETE_SCREENS = '[Screens] Delete Screens';
const CURRENT_DELETE_SCREENS = '[Screens] Current Delete Screens';
const GET_SCREEN_STRUCTURE = '[Screens] Get Screen Structure';
const SET_SCREEN_STRUCTURE = '[Screens] Set Screen Structure';
const UPDATE_SCREEN_STRUCTURE = '[Screens] Set Screen Structure';
const GET_FIELDS_INFO = '[Screens] Get Fields Info';
const SET_FIELDS_INFO = '[Screens] Set Fields Info';
const UPDATE_FIELDS_INFO = '[Screens] Update Fields Info';
const GET_POSSIBLE_CHILDREN = '[Screens] Get possible children';
const SET_POSSIBLE_CHILDREN = '[Screens] Set possible children';
const ALL_POSSIBLE_CHILDREN = '[Screens] All possible children';
const GENERATE_PAGES = '[Screens] Generate Pages';
const GET_CHILD_TABLES = '[Screens] Get Child Tables';
const SET_CHILD_TABLES = '[Screens] Set Child Tables';
const GET_GENERATION_STATUS = '[Screens] Get Generation Status';
const SET_GENERATION_STATUS = '[Screens] Set Generation Status';
const SET_ERROR_MESSAGE = '[Screens] Set Error Message';
const LANDING_SCREEN = '[Screens] Set Landing Screen';
const SAVE_CONF_FLCNT_SUCCESS = '[Screens] Config fields saved';
const SAVE_CONF_FLCNT_FAILURE = '[Screens] Config fields save Failed';
const UPDATE_SCREEN_CONFIG = '[Screens] Config fields And file Content Update';
const GET_TABLE_ORDER = 'Get Table Order';
const SET_TABLE_ORDER = 'set Table Order';
const GET_PAGES_FOR_QUERY = 'Get Pages for Query';
const SET_PAGES_FOR_QUERY = 'Set Pages for Query';
const GET_TABLES_FOR_QUERY = 'Get Tables for Query';
const SET_TABLES_FOR_QUERY = 'Set Tables for Query';
const GET_QUERY_TABLE_DATA = 'Get Query Table Data';
const SET_QUERY_TABLE_DATA = 'Set Query Table Data';
const GET_TABLE_DATA = 'Get Table Data';
const SET_TABLE_DATA = 'Set Table Data';
const GET_MEMBER_SCREEN_DATA = 'Get Member Screen Data';
const SET_MEMBER_SCREEN_DATA = 'Set Member Screen Data';
const GET_STANDARD_PAGES = 'Get Standard List Pages';
const SET_STANDARD_PAGES = 'Set Standard List Pages';
const GET_PAGE_VARIABLES = '[Page] Get Variables';
const SET_PAGE_VARIABLES = '[Page] Set Variables';
const DELETE_PAGE_VARIABLE = '[Page] Delete Variable';
const DELETE_PAGE_VARIABLE_SUCCESS = '[Page] Delete Variable Success';
const SAVE_PAGE_VARIABLE = '[Page] Save Variable';
const SAVE_PAGE_VARIABLE_SUCCESS = '[Page] Save Variable Success';
const QUERY_MAP_DATA = '[Page] Query Map Data';

const getAppNavigation = createAction(GET_APP_NAVIGATION, props<{ appNavApiConstants: any }>());

const setAppNavigation = createAction(SET_APP_NAVIGATION, props<{ appNavStructure: any }>());

const getScreens = createAction(GET_SCREENS, props<{ getScreensApiConstants: any }>());

const getIdMapping = createAction(GET_ID_MAPPING, props<{ getIdMappingApiConstants: any }>());

const setIdMapping = createAction(SET_ID_MAPPING, props<{ idMaps: any }>());

const saveScreens = createAction(SAVE_SCREENS, props<{ saveScreensApiConstants: any; screensData: any }>());

const updateScreens = createAction(UPDATE_SCREENS, props<{ screensApiConstants: any; screensData: any }>());

const updateCurrentScreen = createAction(UPDATE_SCREEN, props<{ updateScreenApi: any; screenData: any }>());

const setSelectedScreens = createAction(SET_SELECTED_SCREENS, props<{ selectedScreens: any }>());

const setNewlyAddedScreen = createAction(SET_SELECTED_SCREENS, props<{ addedScreen: any }>());

const deleteScreens = createAction(DELETE_SCREENS, props<{ deleteScreenApi: any; screensId: any }>());

const currentDeleteScreen = createAction(CURRENT_DELETE_SCREENS, props<{ deletedScreenId: string }>());

const getScreenStructure = createAction(
  GET_SCREEN_STRUCTURE,
  props<{ getScreenStructureApiConstants: any; sid: any }>()
);

const setScreenStructure = createAction(SET_SCREEN_STRUCTURE, props<{ selectedScreenStructure: any }>());

const updateScreenStructure = createAction(
  UPDATE_SCREEN_STRUCTURE,
  props<{ updateStructureApiConstants: any; updatedStructure: any }>()
);

const getFieldsInfoForTable = createAction(GET_FIELDS_INFO, props<{ getFIApiConstants: any }>());

const setFieldsInfoForTable = createAction(SET_FIELDS_INFO, props<{ fieldsInfo: any }>());

const updateFieldsInfoForTable = createAction(UPDATE_FIELDS_INFO, props<{ updateFIApiConstants: any; fiData: any }>());

const getChildrenForElement = createAction(GET_POSSIBLE_CHILDREN, props<{ getChildrenApi: any; fetchType: any }>());

const setChildrenForElement = createAction(SET_POSSIBLE_CHILDREN, props<{ elemChildren: any }>());

const getChildTables = createAction(GET_CHILD_TABLES, props<{ getChildTableApi: any; tableId: any }>());

const setChildTables = createAction(SET_CHILD_TABLES, props<{ childTables: any }>());

const generatePages = createAction(GENERATE_PAGES, props<{ genPagesApi: any; genParams: any }>());

const setErrorMessage = createAction(SET_ERROR_MESSAGE, props<{ errorData: any }>());

const setLandngScreen = createAction(LANDING_SCREEN, props<{ apiConstants: any }>());

const updateLandScr = createAction(LANDING_SCREEN, props<{ landScrId: any }>());

const saveconfAndFileCntSuccess = createAction(SAVE_CONF_FLCNT_SUCCESS, props<{ results: any }>());

const saveconfAndFileCntFailure = createAction(SAVE_CONF_FLCNT_FAILURE, props<{ error: any }>());

const updateScnAndDMCOnfig = createAction(UPDATE_SCREEN_CONFIG, props<{ updateApiCons: any; updatedData: any }>());

const getTableOrder = createAction(GET_TABLE_ORDER, props<{ tableOrderApiConstants: any }>());

const setTableOrder = createAction(SET_TABLE_ORDER, props<{ tableOrder: any }>());
const getPagesForQuery = createAction(GET_PAGES_FOR_QUERY, props<{ queryPagesApiConstants: any }>());

const setPagesForQuery = createAction(SET_PAGES_FOR_QUERY, props<{ queryPages: any }>());

const getTablesForQuery = createAction(GET_TABLES_FOR_QUERY, props<{ queryTblsApiConstants: any }>());

const setTablesForQuery = createAction(SET_TABLES_FOR_QUERY, props<{ queryTables: any }>());

const getQueryTableData = createAction(GET_QUERY_TABLE_DATA, props<{ queryTblDataApiConstants: any; sid: any }>());

const setQueryTableData = createAction(SET_QUERY_TABLE_DATA, props<{ queryTableData: any }>());

const getTableData = createAction(GET_TABLE_DATA, props<{ tblDataApiConstants: any; sid: any }>());

const setTableData = createAction(SET_TABLE_DATA, props<{ tableData: any }>());

const getMsScreenData = createAction(GET_MEMBER_SCREEN_DATA, props<{ msScrDataApiConstants: any; suiteId: any }>());

const setMsScreenData = createAction(SET_MEMBER_SCREEN_DATA, props<{ msScreenData: any }>());

const getStandardListPages = createAction(GET_STANDARD_PAGES, props<{ stdPagesApiConstants: any }>());

const setStandardListPages = createAction(SET_STANDARD_PAGES, props<{ standardPages: any }>());

const getPageVariables = createAction(GET_PAGE_VARIABLES, props<{ getPageVariablesApiConst: any; data: any }>());

const setPageVariables = createAction(SET_PAGE_VARIABLES, props<{ setPageVariablesData: any }>());

const deletePageVariable = createAction(DELETE_PAGE_VARIABLE, props<{ deletePageVariableApiConst: any; data: any }>());

const deletePageVariableSuccess = createAction(
  DELETE_PAGE_VARIABLE_SUCCESS,
  props<{ deletePageVariableSuccessData: any }>()
);

const savePageVariable = createAction(SAVE_PAGE_VARIABLE, props<{ savePageVariableApiConst: any; data: any }>());

const savePageVariableSuccess = createAction(SAVE_PAGE_VARIABLE_SUCCESS, props<{ savePageVariableSuccessData: any }>());

const setQueryMapData = createAction(QUERY_MAP_DATA, props<{ queryMapData: any }>());

export {
  getAppNavigation,
  setAppNavigation,
  getScreens,
  saveScreens,
  updateScreens,
  deleteScreens,
  currentDeleteScreen,
  setSelectedScreens,
  getScreenStructure,
  setScreenStructure,
  updateScreenStructure,
  getFieldsInfoForTable,
  setFieldsInfoForTable,
  updateFieldsInfoForTable,
  getChildrenForElement,
  setChildrenForElement,
  setNewlyAddedScreen,
  getIdMapping,
  setIdMapping,
  generatePages,
  updateCurrentScreen,
  getChildTables,
  setChildTables,
  setErrorMessage,
  setLandngScreen,
  updateLandScr,
  saveconfAndFileCntSuccess,
  saveconfAndFileCntFailure,
  updateScnAndDMCOnfig,
  getTableOrder,
  setTableOrder,
  getPagesForQuery,
  setPagesForQuery,
  getTablesForQuery,
  setTablesForQuery,
  getQueryTableData,
  setQueryTableData,
  getStandardListPages,
  setStandardListPages,
  getTableData,
  setTableData,
  getMsScreenData,
  setMsScreenData,
  getPageVariables,
  setPageVariables,
  deletePageVariable,
  deletePageVariableSuccess,
  savePageVariable,
  savePageVariableSuccess,
  setQueryMapData
};
